"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _Header = _interopRequireDefault(require("./Header"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Main class export
class Wrapper extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowLeft: 0
    };
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "www-wrapper-com"
    }, /*#__PURE__*/_react.default.createElement(_Header.default, {
      lang: this.props.lang,
      open: this.props.open,
      drupalData: this.props.drupalData
    }), this.props.children, /*#__PURE__*/_react.default.createElement(_Footer.default, {
      drupalData: this.props.drupalData,
      lang: this.props.lang
    }));
  }
}
exports.default = Wrapper;
Wrapper.propTypes = {
  lang: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  drupalData: _propTypes.default.object,
  open: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
Wrapper.defaultProps = {
  open: false
};